/**
 * SubscriberDTO entity class
 */

import moment from 'moment'

/**
 * SubscriberDTOFactory
 * returns SubscriberDTO entity class
 *
 * @class SubscriberDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.SubscriberDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:SubscriberDTOFactory
 */
/* @ngInject */
export default function SubscriberDTOFactory (Subscriber) {
  /* === SubscriberDTO class === */

  /**
   * SubscriberDTO model
   *
   * @class SubscriberDTO
   * @classdesc SubscriberDTO model
   * @memberof models
   * @see models
   * @extends models.Subscriber
   * @return {models.SubscriberDTO} SubscriberDTO entity
   */
  function SubscriberDTO () {
    var obj = Subscriber.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  SubscriberDTO.prototype = Object.create(Subscriber.prototype)
  SubscriberDTO.prototype.constructor = SubscriberDTO

  /* === SubscriberDTO instance methods & fields === */

  Object.assign(SubscriberDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.SubscriberDTO#
     * @type {Object}
     */
    _fields: {
      id: Number,
      accountNumber: String,
      accessoryNotes: ['AccessoryNote'],
      autoPay: Boolean,
      createdTime: moment,
      deleted: Boolean,
      devices: ['Device'],
      email: String,
      emailValid: Boolean,
      expirationTime: moment,
      firstName: String,
      hasUnlimitedSubscription: Boolean,
      lastAccessTime: moment,
      lastName: String,
      network: 'Network',
      phone: String,
      subscription: {
        id: Number,
        name: String
      },
      status: String, // SUBSCRIBER_STATUSES
      withCustomContent: Boolean,
      username: String
    },

    /**
     * Get paid devices count
     *
     * @memberof models.SubscriberDTO#
     * @return {Number}
     */
    _paidDeviceCount: function () {
      if (this.__paidDeviceCount === undefined) {
        this.__paidDeviceCount = this.devices.filter(d => d.status && d.enabled).length
      }
      return this.__paidDeviceCount
    }

  })

  /* === SubscriberDTO static methods & fields === */

  // copy all static methods from Subscriber class
  Object.assign(SubscriberDTO, Subscriber)
  SubscriberDTO._name = 'SubscriberDTO'

  SubscriberDTO.extra = {
    networks: ['Network'],
    subscriptions: ['Subscription'],
    batches: ['VoucherBatch'],
    distributors: ['Distributor']
  }
  SubscriberDTO.init()

  return SubscriberDTO
}
